<section>
  <div class="search-box" *ngIf="aemContent">
    <input
      class="form-control"
      type="search"
      #searchResult
      [formControl]="searchFieldFormControl"
      autofocus
      placeholder="{{ aemContent?.searchPlaceholder }}"
      name="search"
      aria-label="search"
      role="search"
      id="txt-input-search-2"
    />
    <span class="search-button">
      <button
        [disabled]="inputSearchTerm?.length <= searchTermMinLength"
        (click)="goToSearchResults()"
        role="button"
        id="btn-default-294"
      >
        {{ aemContent?.go }}
      </button>
    </span>
  </div>
  <ng-container *ngIf="searchLoaded">
    <ng-container *ngIf="isInputZipCode; else alphaNumericSearch">
      <h6 class="m-t-lg">{{ aemContent?.areYouLookingFor }}</h6>
      <p class="small m-t-md">
        <a
          href="javascript:void(0)"
          title="Store"
          (click)="navigateToStoreLocator('https://www.t-mobile.com/store-locator.html', true)"
          id="cta-default-196"
          >{{ inputSearchTerm }} {{ aemContent?.inStoreLocator }}</a
        >
      </p>
      <p class="small m-t-md m-b-lg">
        <a
          href="javascript:void(0)"
          (click)="closeSearch()"
          [routerLink]="['/coverage-map']"
          id="cta-default-197"
          >{{ inputSearchTerm }} {{ aemContent?.inCoverage }}</a
        >
      </p>
    </ng-container>
    <ng-template #alphaNumericSearch>
      <ng-container *ngIf="searchSuggestionModel?.recentSearches?.length > 0">
        <h6 class="m-t-lg">{{ aemContent?.recentSearches }}</h6>
        <p
          class="small m-t-md"
          *ngFor="let recentSearch of searchSuggestionModel?.recentSearches; let ind = index"
        >
          <a
            href="javascript:void(0)"
            (click)="selectSuggestedSearch(recentSearch, 'Recent Search')"
            id="cta-default-198_{{ ind }}"
            >{{ recentSearch }}</a
          >
        </p>
        <hr class="m-t-lg m-b-lg" />
      </ng-container>
      <ng-container *ngIf="searchSuggestionModel?.popularSearches?.length > 0">
        <h6 class="m-t-lg">{{ aemContent?.popularSearches }}</h6>
        <p
          class="small m-t-md"
          *ngFor="let popularSearch of searchSuggestionModel?.popularSearches; let ind = index"
        >
          <a
            href="javascript:void(0)"
            (click)="selectSuggestedSearch(popularSearch, 'Popular Search')"
            id="cta-default-199_{{ ind }}"
            >{{ popularSearch }}</a
          >
        </p>
        <hr class="m-t-lg m-b-lg" />
      </ng-container>
      <ng-container *ngIf="searchSuggestionModel?.categorySearches?.length > 0">
        <div class="m-b-lg">
          <h6 class="m-t-lg">{{ aemContent?.categorySearches }}</h6>
          <p
            class="small m-t-md"
            *ngFor="let categorySearch of searchSuggestionModel?.categorySearches; let ind = index"
          >
            <a
              href="javascript:void(0)"
              (click)="selectSuggestedSearch(categorySearch, 'Category Search')"
              id="cta-default-200_{{ ind }}"
              >{{ categorySearch }}</a
            >
          </p>
        </div>
      </ng-container>
    </ng-template>
  </ng-container>
</section>
